import React from 'react';
import { observer } from 'mobx-react';

import { GridDataEntry } from 'controls/grid/gridDataEntry';
import { QueryBuilder } from 'controls/queryBuilder/queryBuilder';
import { Section } from 'controls/react/layout/section';
import { AntCheckbox } from 'controls/react/ant/antCheckbox';
import { linkModel } from 'framework/mobx-integration';
import { AntFlex } from 'controls/react/ant/antFlex';
import { ViewManagerProps } from 'controls/grid/viewManager/viewManagerProps';

const i18n = require('core/localization/localization').translator({
	'Show inline filters': {},
});

export const FiltersEditor = observer(<DataItem extends GridDataEntry>(props: ViewManagerProps<DataItem>) => {
	const gridStore = props.store.gridStore;

	return (
		<Section appearance={'none'} childrenPadding={true}>
			<AntFlex justify={'flex-end'}>
				<AntCheckbox {...linkModel(gridStore.state, 'showInlineFilters')}>{i18n('Show inline filters')}</AntCheckbox>
			</AntFlex>
			<QueryBuilder rule={gridStore.state.filters} config={gridStore.filtersConfigurationEffective} />
		</Section>
	);
});
